<nb-card>
    <nb-card-header>Some shit</nb-card-header>
    <div class="form-grid-container">
        <div class="form-wrapper">
            <ubs-ofbiz-form [ofbizForm]="addForm" [title]="title" [state]="state" [parameters]="parameters" (openDialogContainerEvent)="openDialogContainer($event)" [lookupSelectedValue]="lookupSelectedValue" [target]="target" (submitResult)="submitResult($event)"></ubs-ofbiz-form>
        </div>
    </div>
</nb-card>
